<app-tables
  [tableHeader]="tableHeader"
  [footerText]="footerText"
  [data]="userList"
  [totalCount]="totalUserCount"
  [columns]="columns"
  [filters]="filters"
  (filtersChange)="filterUserList($event.filters, $event.sort)"
  (onPageChange)="onPageChange($event)"
  (onPageSizeChange)="onPageSizeChange($event)"
  [tableLoading]="userListLoading"
  [totalPage]="totalPage"
  [pageSize]="pageSize"
  (onActionButtonClick)="actionButtonClick($event.actionType, $event.row)"
  [columnWidths]="columnWidths"
  (handleGetUserList)="getUserList(1, pageSize, filters)"
></app-tables>
